import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(auth)/register/Register.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AuthButton","SocialMediaButton"] */ "/app/src/components/Button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Card/Card.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Input/Input.module.scss");
